let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}

function refreshAmpCart(attempt = 0) {
  if (
    typeof window.SLIDECART_UPDATE === 'function' &&
    typeof window.SLIDECART_OPEN === 'function'
  ) {
    window.SLIDECART_UPDATE(() => window.SLIDECART_OPEN());
    return;
  }

  if (attempt < 20) {
    window.setTimeout(() => refreshAmpCart(attempt + 1), 100);
    return;
  }

  window.location = window.routes.cart_url;
}

document.querySelectorAll('[data-product-form-submit]').forEach((button) => {
  button.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const form = button.closest('form');
    if (!form) return;

    const errorWrapper = button.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const errorMessage = errorWrapper?.querySelector('.product-form__error-message');

    button.setAttribute('aria-disabled', true);
    button.classList.add('loading');
    errorWrapper?.setAttribute('hidden', '');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = new FormData(form);

    try {
      const response = await fetch(window.routes.cart_add_url, config).then((result) => result.json());

      if (response.status) {
        if (errorMessage) errorMessage.textContent = response.description || response.message;
        errorWrapper?.removeAttribute('hidden');
        return;
      }

      refreshAmpCart();
    } catch (error) {
      console.error(error);
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    }
  });
});

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButton = this.querySelector('[data-product-form-submit]') || this.submitButton;
        this.submitButtonText = this.submitButton.querySelector('span');
        this.variantIdInput.disabled = this.submitButton.hasAttribute('disabled');
        this.buyNowButton = this.querySelector('.buy-now');

        if (this.buyNowButton) {
          this.buyNowButton.addEventListener('click', this.handleBuyNow.bind(this));
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      handleBuyNow(evt) {
        evt.preventDefault();

        if (this.buyNowButton.getAttribute('aria-disabled') === 'true' || this.buyNowButton.hasAttribute('disabled')) {
          return;
        }
        const variantId = this.variantIdInput.value;
        const quantity = 1;

        if (!variantId) {
          return;
        }

        window.location.href = `/cart/${variantId}:${quantity}?checkout`
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              refreshAmpCart();
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.isSyncing = false; // Flag to prevent recursive sync
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      if (!this.isSyncing) {
        const target = this.getInputForEventTarget(event.target);
        this.updateSelectionMetadata(event);

        // Publish the change to propagate the selection to other `variant-selects`
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });

        // Synchronize other variant-selects elements
        this.syncOtherVariantSelects();
      }
    });
  }

  syncOtherVariantSelects() {
    const otherVariantSelects = document.querySelectorAll('variant-selects');

    otherVariantSelects.forEach((otherSelect) => {
      if (otherSelect !== this) {
        otherSelect.isSyncing = true; // Prevent recursive sync

        this.selectedOptionValues.forEach((value, index) => {
          const selectElement = otherSelect.querySelectorAll('select')[index];
          if (selectElement) {
            Array.from(selectElement.options).forEach((option) => {
              option.selected = option.dataset.optionValueId === value;
            });
          }
        });

        // Trigger change event for the other select to ensure all associated logic executes
        otherSelect.dispatchEvent(new Event('change'));

        otherSelect.isSyncing = false; // Reset flag after sync
      }
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        ?.removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);  
